{
  "title": "Freedom of the Waves (HB)",
  "source": "Tal'Dorei Campaign Setting Reborn",
  "levelAndSchool": "3rd-level conjuration",
  "level": 3,
  "castingTime": "1 action",
  "range": "120 feet",
  "components": "V, S, M (a strand of wet hair)",
  "duration": "Instantaneous",
  "description": [
    "You conjure a deluge of seawater in a 15-foot-radius, 10-foot-tall cylinder centered on a point within range. This water takes the form of a tidal wave, a whirlpool, a waterspout, or another form of your choice. Each creature in the area must succeed on a Strength saving throw against your spell save DC or take 2d8 bludgeoning damage and fall prone. You can choose a number of creatures equal to your spellcasting modifier (minimum of 1) to automatically succeed on this saving throw.",
    "If you are within the spell’s area, as part of the action you use to cast the spell, you can vanish into the deluge and teleport to an unoccupied space that you can see within the spell’s area."
  ],
  "spellLists": ["druid", "ranger", "sorcerer"]
}
